import React from 'react';
import BDPerformanceScreen from './BDPerformanceScreen';

const BDDashboard = () => {
  return <BDPerformanceScreen />;
};

export default BDDashboard;